import { createNavigation } from "next-intl/navigation"
import { defineRouting } from "next-intl/routing"

// Can be imported from a shared config
export const locales = ["he", "en"]

export type Culture = "he-il" | "en-us"

export const cultureMap = {
  he: "he-il",
  en: "en-us",
} as const

export type Locale = "he" | "en"

export const routing = defineRouting({
  locales: locales,

  // If this locale is matched, pathnames work without a prefix (e.g. `/about`)
  defaultLocale: "he",
  localeDetection: false,
  localePrefix: "as-needed",
  alternateLinks: false,
})

export function getDirection(locale: Locale) {
  return locale === "he" ? "rtl" : "ltr"
}
// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing)
